import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../ReduxToolkit/Hooks';
import { Form, Formik } from 'formik';
import { Fragment, useEffect, useState } from 'react';
import { Btn, P } from '../../../AbstractElements';
import { toast } from 'react-toastify';
import { generateReportAPI, getSingleReportAPI, updateReportAPI, uploadDocumentAPI } from '../../../Api/report';
import { setGenerating } from '../../../ReduxToolkit/Reducers/PageSlice';
import PageCreator, { PageFile } from './ReportCreator';

const base64ToBlob = (base64: any, mimeType: any) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};


const CreatePageForm = () => {
  const dispatch = useAppDispatch();
  const { page_id } = useParams();


  const [elements, setElements] = useState<any>([]);
  const [files, setFiles] = useState<PageFile[]>([])
  const [prevPath, setPrevPath] = useState<string>("")
  const [name, setName] = useState<string>("")

  const createPage = async () => {
    try {
      dispatch(setGenerating(true));
      const formData = new FormData();

      files.forEach((file, index) => {
        if (file.file && file.file?.file instanceof File) {
          formData.append("file[]", file.file.file, file.file.name);
          formData.append("fileIds[]", file.id);  // Ensure `file.id` is a valid and non-empty string
        } else {
          console.error("Invalid file or file missing:", file);
        }
      });

      let res;
      if (files.length)
        res = await uploadDocumentAPI(formData);

      if (res?.data?.status === "success" || !files.length) {
        const response = page_id ? await updateReportAPI(page_id, { elements, name }) : await generateReportAPI({ elements, name })

        // Additional handling based on this response
        if (response?.data?.status === "success") {
          toast.success(page_id ? "Page updated successfully!" : "Page created successfully!");

          window.location.href = "/page/list"
        } else {
          toast.error("Failed to save page.");
        }
      } else {
        throw new Error("Failed to save files, files too large or heavy traffic!!!");
      }
      dispatch(setGenerating(false));

    } catch (error) {
      toast.error("An error occurred while creating page.");
      dispatch(setGenerating(false));
    }
  };

  useEffect(() => {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    setPrevPath(params.get('from') || "")
  }, [])

  useEffect(() => {
    if (page_id) {
      const fetchPage = async () => {
        try {
          const { elements, files, name } = await getSingleReportAPI(page_id, false);
          setName(name)
          setElements(elements)
          let _files: any[] = []

          elements.forEach((element: any) => {
            let mimeType = ""
            if (element.type === 'image')
              mimeType = "image/jpeg"
            else if (element.type === 'video')
              mimeType = "video/mp4"
            if (mimeType && element.file_id) {
              const fileTemp = files.filter((file: any) => file.id === element.file_id)[0]
              const blob = base64ToBlob(fileTemp.file, mimeType);
              const _file = new File([blob], fileTemp.filename, { type: mimeType });

              let dropZoneFile = { file: _file, name: _file.name, type: _file.type, valid: true }

              _files = [..._files, { file: dropZoneFile, id: fileTemp.id }]
            }
          })

          setFiles(_files)
        } catch (error) {
          toast.error('Failed to fetch page');
        }
      };

      fetchPage();
    }
  }, [page_id]);
  return (
    <Fragment>


      <Formik initialValues={{}} validationSchema={() => { }} onSubmit={() => { }}>
        {() => (
          <Form className="theme-form">
            <Fragment>
              <div className='d-flex justify-content-end'>
                <Btn color='danger' className='me-3 btn-hover-effect' onClick={() => window.location.href = prevPath}>Go Back</Btn>
                <Btn className='mb-3 btn-hover-effect' color='primary' onClick={createPage}>Save Page</Btn>
              </div>
              {/* <PageEditor file={file} setTags={setTags} setImgWidth={setImgWidth} setImgHeight={setImgHeight} /> */}
              <PageCreator name={name} setName={setName} setFiles={setFiles} files={files} elementsData={elements} setElementsData={setElements} />
            </Fragment>
          </Form>
        )}
      </Formik>
    </Fragment >
  )
}

export default CreatePageForm